module.exports = __webpack_public_path__ + "img/black-week-super-desconto-rodape.1f12d85e.webp";